export default __webpack_public_path__ + "static/media/HST-SIPA1SM.3a972f89.svg";